export const ERROR_CODE = 200;
const apiUrl = process.env.REACT_APP_BACKEND_URL;

export const getCurrentUser = async (token, id) => {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };

  const res = await fetch(`${apiUrl}users/current`, requestOptions);

  return await res
    .json()
    .then(res => {
      return res;
    })
    .catch(err => {
      console.log(err);
      return ERROR_CODE;
    });

  // TODO: maybe transform result into a custom object with status, code, and value?
};

//possible for specific customer, or token customer
export const getUserBuildingsDetails = async customerId => {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const res = await fetch(`${apiUrl}users/buildings-details/${customerId}`, requestOptions);

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return data; // Return the buildings array directly
  } catch (error) {
    console.error('getUserBuildingsDetails error:', error);
    throw error;
  }
};

//possible for specific customer, or token customer
export const getUserBuildingDetails = async buildingId => {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const res = await fetch(`${apiUrl}users/building-details/${buildingId}`, requestOptions);

    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      const error = new Error(body.error || `HTTP error! status: ${res.status}`);
      error.statusCode = res.status;
      throw error;
    }

    const data = await res.json();
    return data; // Return the buildings array directly
  } catch (error) {
    console.error('getUserBuildingsDetails error:', error);
    throw error;
  }
};

export const getUsersDetails = async () => {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const res = await fetch(`${apiUrl}users/user-details`, requestOptions);

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error('getUsersDetails error:', error);
    throw error;
  }
};

export const getPermissionDevices = async () => {
  const response = await fetch(`${apiUrl}permissions/devices`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const updatePermissionDevice = async ({ devices, isAllowed }) => {
  const response = await fetch(`${apiUrl}permissions/devices`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ devices, is_allowed: isAllowed }),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const deletePermissionDevice = async ({ ip, mac, devices }) => {
  const response = await fetch(`${apiUrl}permissions/devices`, {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(Array.isArray(devices) ? { devices } : { ip, mac }),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `HTTP error! status: ${response.status}`);
  }

  return response.json();
};

// USERS OPERATIONS
export const createUser = async userData => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(userData),
  };

  const response = await fetch(`${apiUrl}users/user`, requestOptions);
  const data = await response.json();

  // Check for HTTP errors or logical errors in the response
  if (!response.ok || !data.success) {
    throw new Error(data.error || data.message || 'Create user failed');
  }

  return data;
};

export const updateUser = async userData => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(userData),
  };

  const response = await fetch(`${apiUrl}users/user`, requestOptions);
  const data = await response.json();

  // Check for HTTP errors or logical errors in the response
  if (!response.ok || !data.success) {
    throw new Error(data.error || data.message || 'Update user failed');
  }

  return data;
};

export const deleteUser = async userId => {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const response = await fetch(`${apiUrl}users/user/${userId}`, requestOptions);
  const data = await response.json();

  // Check for HTTP errors or logical errors in the response
  if (!response.ok || !data.success) {
    throw new Error(data.error || data.message || 'Delete user failed');
  }

  return data;
};

export const deleteUserPermissions = async userId => {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const response = await fetch(`${apiUrl}users/user/permissions/${userId}`, requestOptions);
  const data = await response.json();

  // Check for HTTP errors or logical errors in the response
  if (!response.ok || !data.success) {
    throw new Error(data.error || data.message || 'Delete user permissions failed');
  }

  return data;
};

export const updateUserPassword = async newPassword => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(newPassword),
  };

  const response = await fetch(`${apiUrl}users/new-password`, requestOptions);
  const data = await response.json();

  // Check for HTTP errors or logical errors in the response
  if (!response.ok || !data.success) {
    throw new Error(data.error || data.message || 'Update building failed');
  }
  return data;
};

export const updatePermissions = async permissionData => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(permissionData),
  };

  const response = await fetch(`${apiUrl}users/permissions`, requestOptions);
  const data = await response.json();

  // Check for HTTP errors or logical errors in the response
  if (!response.ok || !data.success) {
    throw new Error(data.error || data.message || 'Update permissions failed');
  }

  return data;
};
